export const SET_SEARCH_HOME = "SET_SEARCH_HOME";
export const CLEAR_SEARCH_HOME = "CLEAR_SEARCH_HOME";
